import EinsModal from 'eins-modal';
import LazyLoad from "vanilla-lazyload";
import ldCover from 'ldcover';

export default new class Cart {
    constructor() {
        this.opacityPromise = 0.7;
        this.options = {
            openTransition: 'expandIn',
            openDuration: 400,
            closeTransition: 'expandOut',
            closeDuration: 10,
            backdropClose: true,
            multiple: false,
            wait: true
        };

        this.modalId        = 'cartModal';
        this.cartContainer  = '.cart-container';

        this.addCartClass   = '.add-cart';
        this.showCartClass  = '._show-cart';

        this.addIncrementClass = '.inc';
        this.addDecrementClass = '.dec';

        this.showHandlers = [
            'cart::onShow', 
            'cart::onBuy'
        ];

        this.promiseHandlers = [
            'cart::onAdd',
            'cart::onUpdate',
            'cart::onDelete',
            'cart::onIncrement',
            'cart::onDecrement'
        ];

        this.init();
    }

    load() {
        const container = document.querySelector(`${this.cartContainer}`);
        
        let that = this;
        container.addEventListener('ajax:update', () => {
            that.cartSuccess(container);
        });

        addEventListener('ajax:promise', (e) => {
            const { context } = e.detail;

            if( this.promiseHandlers.includes(context.handler) ) {
                this.cartPromise(container);
            }  
        });
    }

    init() {

        const container = document.querySelector(`${this.cartContainer}`);

        if(null === container) {
            return;
        }

        this.incrementWidget();
        this.decrementWidget();

        this.initInputQuantity();

        document.addEventListener('click', (el) => {
            if (!el.target.matches(`${this.addCartClass}`)) return;

            el.preventDefault();

            const id = el.target.getAttribute('data-id');
            let quantity = el.target.getAttribute('data-quantity');

            if(typeof id === "undefined" || null === id) {
                return;
            }

            if(typeof quantity === "undefined" || null === quantity) {
                quantity = 1
            }

            let quantityNode = this.inputQuantity(el, 'outer');

            if(null != quantityNode) {
                quantity = quantityNode.value;
            }

            this.buy(id, quantity);
        });

        document.addEventListener('click', (el) => {
            if (!el.target.matches(`${this.showCartClass}`)) return;

            el.preventDefault();

            this.show();
        });

        /* backdrop close
        addEventListener('click', function(e){

            if (!e.target.matches('.form-close')) return;

            modal.modal('hide');
        });
        */

        /*
        modal.addEventListener('hide.eins.modal', () => {
            
            while(container.firstChild){
                container.removeChild(container.firstChild);
            }
            
        });
        */

        /*
        addEventListener('form:success', () => {
            modal.modal('hide');
        });
        */

        let that = this;
        container.addEventListener('ajax:update', () => {
            that.cartSuccess(container);
        });        

        addEventListener('ajax:promise', (e) => {
            const { context } = e.detail;

            if( this.showHandlers.includes(context.handler) ) {
                callModal('cart');
            }
        
            if( this.promiseHandlers.includes(context.handler) ) {
                this.cartPromise(container);
            }  
        });
    }

    incrementWidget() {
        document.addEventListener('click', (el) => {
            if (!el.target.matches(`${this.addIncrementClass}`)) return;

            let quantityNode = this.inputQuantity(el, 'inner');

            if(null == quantityNode) return;

            quantityNode.value = parseInt(quantityNode.value) + 1;
        });
    }

    decrementWidget() {
        document.addEventListener('click', (el) => {
            if (!el.target.matches(`${this.addDecrementClass}`)) return;

            let quantityNode = this.inputQuantity(el, 'inner');

            if(null == quantityNode) return;

            quantityNode.value = parseInt(quantityNode.value) > 1 
                ? parseInt(quantityNode.value) - 1 
                : 1;
        });
    }

    cartPromise (container) {
        container.style.opacity = this.opacityPromise;
    }

    cartSuccess (container) {
        // add listeners to inputs
        container.style.opacity = 1.0;
        this.initInputQuantity();
        new LazyLoad();
    }

    handleQuantityInput(input) {
        let delay = this.makeDelay(400);
        input.addEventListener('keyup', (el) => {

            delay(() => {
                const id = el.target.getAttribute('data-id');
                let quantity = el.target.value;

                this.updateCart(id, quantity)
            });
    
        });
    }

    // ajax handlers
    show() {
        this.request("cart::onShow");
    }

    buy(id, quantity) {
        this.request("cart::onBuy", { id, quantity });
    }
    
    addCart(id, quantity) {
        this.request("cart::onAdd", { id, quantity }); 
    }

    updateCart(id, quantity) {
        this.request("cart::onUpdate", { id, quantity }); 
    }

    request(handler, data = null) {
        oc.ajax(handler, { 
            data, 
            success: function(data) {
                this.success(data);
            }
        });
    }

    // inputQuantityNode
    inputQuantity(el, context) {
        let quantityNode = null;

        let inputContainer;
        if(context == 'outer') {
            inputContainer = el.target.previousElementSibling;
        }

        if(context == 'inner') {
            inputContainer = el.target.parentNode; 
        }

        if(inputContainer == null) {
            return null;
        }
            
        // find input
        for (var i = 0; i < inputContainer.childNodes.length; i++) {
            if(inputContainer.childNodes[i].tagName == 'INPUT') {
                quantityNode = inputContainer.childNodes[i];
            }
        }

        return quantityNode;
    }

    initInputQuantity() {
        document.querySelectorAll('.input-cart-quantity').forEach(el => this.handleQuantityInput(el));
    }

    // helper delay function
    makeDelay(ms) {
        var timer = 0;
        return function(callback){
            clearTimeout (timer);
            timer = setTimeout(callback, ms);
        };
    };
        
}();